import {KpiApi} from '@/api/KpiApi'
import Kpi from "@/models/Kpi";
export default {
  async getKpiData ({ commit }, kpiId) {
    try {
      const { data } = await KpiApi.getKpiId(kpiId)
      commit('setKpi', new Kpi(data))
      return true
    } catch (e) {
      throw new Error(e)
    }
  }
}
